export default `
  fragment ParagraphScheduleWidgetFees on ParagraphScheduleWidgetFees {
    uuid
    entityBundle
    title
    fieldSchedule {
      entity {
        ...NodeSchedule
      }
    }
  }
`
